import { render, staticRenderFns } from "./CheckListAnexos.vue?vue&type=template&id=c5d63556&scoped=true&"
import script from "./CheckListAnexos.vue?vue&type=script&lang=js&"
export * from "./CheckListAnexos.vue?vue&type=script&lang=js&"
import style0 from "./CheckListAnexos.vue?vue&type=style&index=0&id=c5d63556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5d63556",
  null
  
)

export default component.exports